import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { Ref, computed, defineComponent, nextTick, reactive, ref, toRefs, watch } from "vue";
import { FlowStatusTab } from "../index";
import { HmdListPage, TableWrapper } from "@/components";
import mixins from "@/core/mixins/table-height.mixins";
import { lastTimeSort } from "@/core/mixins/lastTimeSort";
import { getList } from "./list.service";
import { PaginationReq } from "@/core";
import { Form } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import { SettingOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  isGlobal: true,
  name: "ListContainer",
  components: { FlowStatusTab, HmdListPage, SettingOutlined },

  props: {
    bizType: {
      type: String,
      require: true,
    },
    queryRef: {
      type: Object,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    apiUrl: {
      type: String,
      require: true,
    },
    exportConfig: {
      // 导出配置
      type: Object,
      default: () => null,
    },
    recycleBinConfig: {
      // 恢复及彻底删除权限配置
      type: Object,
      default: () => null,
    },
    operationExternalData: {
      // 流程外的按钮
      type: Object,
      default: () => [],
    },

    flowConfig: {
      // 流程按钮配置
      type: Object,
      default: () => {},
    },
    flowStatus: {
      type: String,
      default: "all",
    },
    bizNameKey: {
      type: String,
    },
    statusKey: {
      type: String,
      default: "status",
    },
    other: {
      type: Function,
    },
    method: {
      type: String,
      default: "GET",
    },
    showCustomSetting: {
      type: Boolean,
      default: false,
    },
    isShowCreateTime: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    "update:queryRef",
    "update:flowStatus",
    "change",
    "getStatusList",
    "reset",
    "getDataSource",
  ],
  setup(props, { slots, emit }) {
    const state = reactive<{
      // tableRef: Ref<any>;
      flowTabRef: Ref<any>;
      params: any;
      childKey: number;
      filterTotalAmount: any;
      isDeletedStatus: boolean;
      allTotalMoney: number;
    }>({
      // tableRef: ref(),
      params: new PaginationReq(),
      childKey: 0,
      isDeletedStatus: false,
      flowTabRef: ref(),
      filterTotalAmount: '',
      allTotalMoney: 0
    });
    const route = useRoute();
    const router = useRouter();
    let routeQuery = route.query;
    let tableRef = ref();
    const status = ref(props.flowStatus);
    // computed(() => {
    //   return props.flowStatus
    // })
    const loadQuery = () => {
      routeQuery = route.query;
      // console.log('routeQuery',routeQuery);
      for (let key in routeQuery) {
        if (typeof routeQuery[key] === 'string' && routeQuery[key] && routeQuery[key]?.indexOf(",") !== -1) {
          let newValue = routeQuery[key] as string
          routeQuery[key] = newValue.split(',')
           //@ts-ignore
          if(routeQuery[key].length>0){
            //@ts-ignore
            routeQuery[key]=routeQuery[key].filter((item:any) => item!='');
          }
         
        }
        if(Array.isArray(routeQuery[key])){
           //@ts-ignore
          let newValue = routeQuery[key].join(',').split(',')
          routeQuery[key] = newValue;
          //@ts-ignore
          if(routeQuery[key].length>0){
            //@ts-ignore
            routeQuery[key]=routeQuery[key].filter((item:any) => item!='');
          }
        }
        if(routeQuery[key]==''){
          routeQuery[key]=null
        }
      }
      props.queryRef?.merge(routeQuery);
      if(routeQuery['flowStatus']) {
        //@ts-ignore
        status.value = routeQuery['flowStatus'];
      }
      emit("update:queryRef", props.queryRef);
    };

    const { setTableHeight, tableHeight, diff } = mixins();
    const { resetFields } = Form.useForm(state.params, reactive({}));
    let { data: dataSource, run, refresh: refreshTable, pagination, loading } = getList();
    let cancleAxios: any = null;
    const tableSlot = computed(() => {
      let s = {};
      for (let key in slots) {
        // console.log("🚀 ~ file: list-container.controller.ts:46 ~ tableSlot ~ key:", key);
        key !== "query" && key !== "operationEx" && (s[key] = slots[key]);
      }

      return s;
      // slots
    });
    const exportColumn = ref<Array<{ name: string; attributeValue: string }>>([]);
    let tableColumn = computed(() => {
      let col: any = [
        ...props.columns,
        {
          title: "删除时审批状态",
          width: 130,
          dataIndex: "flowStatusName",
          key: "flowStatusName",
          showFlowStatus: ["hsz"],
        },
        {
          title: "删除原因",
          width: 100,
          dataIndex: "recycleDesc",
          key: "recycleDesc",
          showFlowStatus: ["hsz"],
        },
      ];
      if (props.isShowCreateTime) {
        col.push({
          title: "创建时间",
          width: 160,
          dataIndex: "createTime",
          key: "createTime",
        });
      }
      return col;
    });
    const handleColumns = () => {
      if (status.value === "hsz") {
        state.isDeletedStatus = true;
      } else {
        state.isDeletedStatus = false;
      }
      exportColumn.value = [];
      for (let i = 0; i < tableColumn.value.length; i++) {
        if (
          tableColumn.value[i]["showFlowStatus"] &&
          !tableColumn.value[i]["showFlowStatus"].includes(status.value)
        ) {
          tableColumn.value[i]["isShow"] = false;
        } else {
          tableColumn.value[i]["isShow"] = true;
        }
        if (!!tableColumn.value[i]["isShow"] && tableColumn.value[i]["title"] != "操作") {
          exportColumn.value.push({
            name: tableColumn.value[i]["title"],
            attributeValue: tableColumn.value[i]["key"] || tableColumn.value[i]["dataIndex"],
          });
        }
      }
      // state.tableRef.updateColumns();
    };
    onMountedOrActivated(async () => {
      setTableHeight();
      loadQuery();
      state.params.current = 1;
      handleColumns();
      emit("update:flowStatus", status.value);
      cancleAxios = null;
      await search();
    });
    const search = async () => {
      const cancelToken = new axios.CancelToken(function executor(c) {
        cancleAxios = c;
      });
      let res = props.apiUrl === '/purchase_order/page' ? await run(
        props.apiUrl,
        {
          ...props.queryRef,
          ...state.params,
          flowStatus: ["all", "hsz"].includes(status.value) ? undefined : status.value,
          isRecycled: status.value == "hsz" ? 1 : 0,
          filterNumFlag: 0,
        },
        cancelToken,
        props.method
      ) : await run(
        props.apiUrl,
        {
          ...props.queryRef,
          ...state.params,
          flowStatus: ["all", "hsz"].includes(status.value) ? undefined : status.value,
          isRecycled: status.value == "hsz" ? 1 : 0,
        },
        cancelToken,
        props.method
      );

      if (res.respCode === "0000") {
        state.filterTotalAmount = res.data.filterTotalAmount
        // console.log('filterTotalAmount', state.filterTotalAmount);
        
      }
      // console.log('filterTotalAmount', state.filterTotalAmount);

      // console.log('111resli', res);
      
      selectedIds.value = [];
      state.flowTabRef?.handleArr();
    };
    watch(
      () => status.value,
      async (n) => {
        state.params.current = 1;
        if (n === "yzf") {
        }
        handleColumns();
        emit("update:flowStatus", status.value);
        // if (!Object.values(routeQuery).length) {
        cancleAxios && cancleAxios();
        await search();
        // }
      },
      {
        // immediate:true
      }
    );
    const reset = async () => {
      // console.log("🚀 ~ file: list-container.controller.ts:180 ~ reset ~ 1111:", 1111);
      state.allTotalMoney = 0;
      emit("reset");
      resetFields();
      selectedIds.value = [];
      resetSort();
      tableRef.value.clearSort();
      (routeQuery = {}),
        router.replace({
          path: route.path,
        });
      await search();
    };
    const onTableChange = async (o) => {
      state.params.current = o.current;
      state.params.size = o.pageSize;
      selectedIds.value = [];
      state.allTotalMoney = 0;
      await search();
    };
    const rs = (d?) => {
      // console.log("🚀 ~ file: list-container.controller.ts:77 ~ rs ~ d:", d?.record);
      return d ? d.record : {};
      // state.childKey++
    };
    const selectedIds = ref<string[]>([]);
    const { lastTimeEvent, resetSort } = lastTimeSort(state, search, "params");
    const onSelectionChange = (ids: string[], row) => {
      // console.log('props/bizType', props.bizType);
      
      selectedIds.value = ids;
      let checkArr = dataSource.value.filter(item => ids.includes(item.id));
      if (props.bizType == 'settlement_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.settlementAmount || 0), 0);
      }else if (props.bizType == 'receipt_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.currentCollectionAmount || 0), 0);
      }else if (props.bizType == 'payment_order_external_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.paymentAmount || 0), 0);
      }else if (props.bizType == 'margin_payment_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.assuringMoney || 0), 0);
      }else if (props.bizType == 'margin_return_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.assuringMoney || 0), 0);
      }else if (props.bizType == 'expense_account_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.expenseAmount || 0), 0);
      }else if (props.bizType == 'make_invoice_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
      }else if (props.bizType == 'income_invoice_examine') {
        state.allTotalMoney = checkArr.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
      }
      
      emit("getDataSource", dataSource.value);
    };
    const refresh = () => {
      refreshTable();
      state.flowTabRef?.handleArr();
    };
    const setCol = () => {
      const $table = tableRef.value;
      if ($table) {
        $table.xTable1.openCustom();
      }
    };
    const isIframe = window.self !== window.top;
    return {
      ...toRefs(state),
      reset,
      status,
      search,
      setTableHeight,
      onSelectionChange,
      onTableChange,
      lastTimeEvent,
      tableHeight,
      tableSlot,
      pagination,
      refresh,
      rs,
      loading,
      dataSource,
      selectedIds,
      tableColumn,
      exportColumn,
      tableRef,
      setCol,
      isIframe
    };
  },
});
